// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-bar[data-v-134103c3]{background-color:#f2f2f2}.page-title[data-v-134103c3]{font-size:16px;font-weight:500;color:#4f3f3e}.exit-button[data-v-134103c3]{width:160px!important;height:48px!important}.exit-button-text[data-v-134103c3]{font-size:16px;font-weight:400;letter-spacing:.002em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
